export default {
    business: {
        tag: '标签',
        del_carrier: '删除',
        alarm_trigger: '报警触发',
        import_carrier: '导入资产',
        carrier_status: '资产状态',
        alarm_status: '报警',
        carrier_equipment: '资产设备',
        carrier_detail: '资产详细',
        record_point: '记录点',
        traceable: '可追踪',
        untraceable: '不可追踪',
        curAbnormal: '当前是否异常',
        carrried: '已挂载',
        device: '设备',
        isTraceable: '是否可跟踪',
        relation: '关联',
        unbind: '解绑',
        add_carrier: '新增',
        is_abnormal: '是否异常'
    }
};
